var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20.5508C3 21.4062 3.65625 21.9688 4.76953 21.9688H9.71484C9.80859 24.2305 11.5781 26.2109 14.0508 26.2109C16.5352 26.2109 18.3047 24.2422 18.3984 21.9688H23.3438C24.4453 21.9688 25.1133 21.4062 25.1133 20.5508C25.1133 19.3789 23.918 18.3242 22.9102 17.2812C22.1367 16.4727 21.9258 14.8086 21.832 13.4609C21.75 8.84375 20.5547 5.86719 17.4375 4.74219C17.0391 3.20703 15.7852 2 14.0508 2C12.3281 2 11.0625 3.20703 10.6758 4.74219C7.55859 5.86719 6.36328 8.84375 6.28125 13.4609C6.1875 14.8086 5.97656 16.4727 5.20312 17.2812C4.18359 18.3242 3 19.3789 3 20.5508ZM5.27344 20.1992V20.0586C5.48438 19.7188 6.1875 19.0273 6.79688 18.3477C7.64062 17.4102 8.03906 15.8984 8.14453 13.6133C8.23828 8.49219 9.76172 6.86328 11.7656 6.3125C12.0586 6.24219 12.2227 6.10156 12.2344 5.79688C12.2695 4.57812 12.9727 3.72266 14.0508 3.72266C15.1406 3.72266 15.832 4.57812 15.8789 5.79688C15.8906 6.10156 16.043 6.24219 16.3359 6.3125C18.3516 6.86328 19.875 8.49219 19.9688 13.6133C20.0742 15.8984 20.4727 17.4102 21.3047 18.3477C21.9258 19.0273 22.6172 19.7188 22.8281 20.0586V20.1992H5.27344ZM11.543 21.9688H16.5703C16.4766 23.5625 15.4688 24.5586 14.0508 24.5586C12.6445 24.5586 11.625 23.5625 11.543 21.9688Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1133,
    height: 24.2227,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.0e8008a269b39da788eedd5561cd809f.svg";
export { ForwardRef as ReactComponent };